import NotNullCheck from "../util/NotNullCheck";
import {rnd} from "../util/Validation";

export const paymentCreditCard = {
    nameSurname: null,
    creditCardNumber: null,
    expiryDate: null,
    cvv: null,
    mail: null,
    distanceSalesContract: false
}

export const validation = (user, t) => {
    const valid = {
        nameSurname: (user.nameSurname == null || !user.nameSurname) ? t('error.empty_name_surname') : null,
        creditCardNumber: (user.creditCardNumber == null || !user.creditCardNumber) ? rnd(t('error.empty_credit_card_number')) :
            (user.creditCardNumber?.length < 14 ? rnd(t('error.empty_credit_card_number')) : null),
        expiryDate: (user.expiryDate == null || !user.expiryDate) ? rnd(t('error.expiry_date')) :
            (!checkExpiryDate(user.expiryDate) ? rnd(t('error.expiry_date_format')) : null),
        cvv: (user.cvv == null || !user.cvv) ? rnd(t('error.empty_cvv')) : (user.cvv?.length === 3 || user.cvv?.length === 4 ? null : rnd(t('error.empty_cvv'))),
        mail: (user.mail == null || !user.mail) ? rnd(t('error.empty_mail_payment')) :
            (!checkEmail(user.mail) ? rnd(t('error.empty_mail_payment_format')) : null),
        distanceSalesContract: (user.distanceSalesContract == null || !user.distanceSalesContract) ? t('error.empty_approve') : null
    }
    valid.error = !NotNullCheck(valid);
    return valid;
}

const checkExpiryDate = (expiryDate) => {
    let year = new Date().getFullYear().toString().substring(2);
    let month = new Date().getMonth() + 1;
    let date = expiryDate.split("/");
    if (parseInt(date[0]) <= 12 && parseInt(date[1]) <= 99 && parseInt(date[0]) > 0)
        if (parseInt(year) < parseInt(date[1])) return true;
        else return parseInt(month) <= parseInt(date[0]) && parseInt(year) === parseInt(date[1]);
    else return false;
}

const checkEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
